'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var ClaimSummaryAppeasementOption = require('./ClaimSummaryAppeasementOption.js');
var nthHookSettings = require('@narvar/nth-hook-settings');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var zod = require('zod');
var styled = require('styled-components');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const ClaimSummaryAppeasementOptionsContainer = styled__default["default"].div.withConfig({
  componentId: "sc-mir85u-0"
})(["display:flex;flex-direction:column;gap:1rem;"]);
const appeasementOptionsSchema = zod.z.array(zod.z.object({
  type: zod.z.enum(['Refund', 'Replacement'])
}));
const ClaimSummaryAppeasement = _ref => {
  let {
    appeasement,
    setAppeasement
  } = _ref;
  const {
    claimsSummaryAppeasementRefundDescription,
    claimsSummaryAppeasementRefundTitle,
    claimsSummaryAppeasementReplacementDescription,
    claimsSummaryAppeasementReplacementTitle
  } = nthHookTranslations.useTranslations();
  const {
    claimAppeasements
  } = nthHookSettings.useSettings();
  const appeasementUiMapping = {
    Refund: {
      title: claimsSummaryAppeasementRefundTitle ?? '',
      description: claimsSummaryAppeasementRefundDescription ?? ''
    },
    Replacement: {
      title: claimsSummaryAppeasementReplacementTitle ?? '',
      description: claimsSummaryAppeasementReplacementDescription ?? ''
    }
  };
  const appeasementOptions = appeasementOptionsSchema.parse(claimAppeasements === null || claimAppeasements === void 0 ? void 0 : claimAppeasements.options);
  return /*#__PURE__*/React__default["default"].createElement(ClaimSummaryAppeasementOptionsContainer, null, appeasementOptions.map(option => /*#__PURE__*/React__default["default"].createElement(ClaimSummaryAppeasementOption["default"], {
    key: option.type,
    name: "appeasement",
    value: option.type,
    title: appeasementUiMapping[option.type].title,
    description: appeasementUiMapping[option.type].description,
    selected: (appeasement === null || appeasement === void 0 ? void 0 : appeasement.type) === option.type,
    onChange: e => setAppeasement({
      type: e.target.value
    })
  })));
};
var ClaimSummaryAppeasement$1 = nthHookSettings.withSettingsProvider(nthHookTranslations.withTranslationsProvider(ClaimSummaryAppeasement, {
  translationKeys: ['claimsSummaryAppeasementRefundDescription', 'claimsSummaryAppeasementRefundTitle', 'claimsSummaryAppeasementReplacementDescription', 'claimsSummaryAppeasementReplacementTitle']
}), {
  settingsRequested: `
		claimAppeasements {
			enabled
			options {
				type
			}
		}
	`
});

exports["default"] = ClaimSummaryAppeasement$1;
